import { render, staticRenderFns } from "./OrdersRates.vue?vue&type=template&id=f1de1098&scoped=true"
import script from "./OrdersRates.vue?vue&type=script&lang=js"
export * from "./OrdersRates.vue?vue&type=script&lang=js"
import style0 from "./OrdersRates.vue?vue&type=style&index=0&id=f1de1098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1de1098",
  null
  
)

export default component.exports